import { Complete } from "@/components/common/Complete";
import { useAuth } from "@/utils/auth";
import { createFileRoute } from "@tanstack/react-router";
import { HeartPulse } from "lucide-react";

// Define static text content for different roles
const content = {
	patient: {
		title: "Welcome to Patient Watch!",
		description: "Help your care team by tracking your recovery journey!",
	},
	clinician: {
		title: "Welcome to Patient Watch!",
		description:
			"Give patients personalised care, save appointments and gather valuable insights into your treatments.",
	},
	secretary: {
		title: "Welcome to Patient Watch!",
		description:
			"Manage patient records and coordinate care efficiently across your team.",
	},
	manager: {
		title: "Welcome to Patient Watch!",
		description:
			"Track how the care team are gathering data across your organization.",
	},
};

const Welcome = () => {
	const { roles } = useAuth();

	// Determine which content to use based on role
	const roleContent = roles.isSecretary
		? content.secretary
		: roles.isClinician
			? content.clinician
			: roles.isManager
				? content.manager
				: content.patient;

	return (
		<Complete
			title={roleContent.title}
			description={roleContent.description}
			icon={HeartPulse}
			loadingText="Setting up your account..."
			loadingDescription="We're getting everything ready for you"
			primaryButton={{
				text: "Continue to Profile Setup",
				to: "/onboarding/name",
			}}
		/>
	);
};

export const Route = createFileRoute("/onboarding/welcome")({
	component: Welcome,
});
